import {BuildingModel} from "@game/coregame/interfaces/BuildingModel";
import {Command} from "@game/coregame/interfaces/Command";
import {DecisionType} from "@game/coregame/interfaces/DecisionType";
import {IBotConfig} from "@game/coregame/interfaces/IBotConfig";
import {PlayerType} from "@game/coregame/interfaces/PlayerType";
import {BState} from "./BState";

const GetMyBuildings = (buildings: BuildingModel[], owner: PlayerType) =>
    buildings.filter(b => b.Owner == owner);
const GetNotMyBuildings = (buildings: BuildingModel[], owner: PlayerType) =>
    buildings.filter(b => b.Owner !== owner);
function* MathExtensions_Combinations(selectAmount: number, length: number) {
    var result = new Array(selectAmount);
    var stack = new Array();
    stack.push(0);

    while (stack.length > 0) {
        var index = stack.length - 1;
        var value = stack.pop();

        while (value < length) {
            result[index++] = value++;
            stack.unshift(value);

            if (index == selectAmount) {
                yield result;
            }
        }
    }
}

export class CommandsGenerator {
    public static GeneratePossibleCommands(state: BState, owner: PlayerType, preset: IBotConfig) {
        const commands: Command[] = [];
        commands.push(...this.GenerateAttackCommands(state, owner, preset));
        commands.push(...this.GenerateDefenceCommands(state, owner, preset));
        commands.push(...this.GenerateWaitCommands(state, owner));

        if (commands.length < 1) {
            return [{Type: DecisionType.Wait}] as Command[];
        }

        return commands;
    }

    static GenerateAttackCommands(state: BState, owner: PlayerType, preset: IBotConfig): Command[] {
        const commands: Command[] = [];

        const playersBuildings = GetMyBuildings(state.buildings, PlayerType.First).length;
        if (
            preset.alivePlayerBuildingsLimit != -1 &&
            preset.alivePlayerBuildingsLimit > playersBuildings
        )
            return commands;

        const my = GetMyBuildings(state.buildings, owner);

        var selectAmountLimit = Math.min(my.length, preset.maxBuildingsMove);
        for (let i = 1; i <= selectAmountLimit; i++) {
            const combinations = MathExtensions_Combinations(i, my.length);

            const notMy =
                preset.alivePlayerBuildingsLimit == playersBuildings
                    ? GetMyBuildings(state.buildings, PlayerType.Neutral)
                    : GetNotMyBuildings(state.buildings, owner);

            for (const enemy of notMy) {
                for (const combination of combinations) {
                    const source: BuildingModel[] = [];
                    for (const index of combination) {
                        source.push(my[index]);
                    }
                    commands.push({
                        Type: DecisionType.Move,
                        Objects: source,
                        Subject: enemy
                    });
                }
            }
        }

        return commands;
    }

    static GenerateDefenceCommands(
        state: BState,
        owner: PlayerType,
        preset: IBotConfig
    ): Command[] {
        const commands: Command[] = [];
        const myBuildings = GetMyBuildings(state.buildings, owner);
        const selectAmountLimit = Math.min(myBuildings.length, preset.maxBuildingsMove);

        for (let i = 1; i <= selectAmountLimit; i++) {
            var combinations = MathExtensions_Combinations(selectAmountLimit, myBuildings.length);
            for (const my of myBuildings) {
                for (const combination of combinations) {
                    let isNeedToPass = false;
                    const source: BuildingModel[] = [];
                    for (const index of combination) {
                        const building = myBuildings[index];
                        // remove cases when the same building placed in target and in source
                        if (building == my) {
                            isNeedToPass = true;
                            break;
                        }

                        source.push(building);
                    }

                    if (isNeedToPass) continue;

                    commands.push({
                        Type: DecisionType.Move,
                        Objects: source,
                        Subject: my
                    });
                }
            }
        }
        return commands;
    }

    static GenerateWaitCommands(state: any, owner: PlayerType): Command[] {
        return [{Type: DecisionType.Wait, Objects: [], Subject: {} as BuildingModel}];
    }
}
